export default "__VITE_ASSET__BpcvnYUa__"